import React, {useState, useEffect} from 'react';

import './izvestaji.styles.css';
import {useHttpClient} from '../../utils/input/http-hook';
import LoadingSpinner from '../../utils/loader/LoadingSpinner';
import Pagination from '../../utils/pagination/pagination';
import Search from '../../utils/search/search'

import IzvestajiList from '../../components/izvestajlist/izvestajlist.component';

const Izvestaji = () => {  

    const[page, setPage ] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState('');
    const[isActive, setIsActive] = useState(1);
        const { isLoading, error, sendRequest, clearError } = useHttpClient();
        const [loadedIzvestaji, setLoadedIzvestaji] = useState([]);       
        useEffect(() => {          
          const fetchIzvestaji = async () => {
            try {
              const responseData = await sendRequest(
                process.env.REACT_APP_BECKEND_URL+`/izvestaji?search=${search}&page=${currentPage}`
              );            
      
              setLoadedIzvestaji(responseData.izvestaji);
              setPage(responseData.count);
            } catch (err) {}
          };
          fetchIzvestaji();
         
        }, [sendRequest, currentPage, search]);

        

        const paginate = pageNumber => {setCurrentPage(pageNumber); setIsActive(pageNumber)};

        const onSearch = term => {setSearch(term) }
        
       return (
        <div className="izvestaj-page">
          <h1 className="heading-secondary u-margin-bottom-medium heading-izvestaji-page">Gde Smo Bili</h1>
         {isLoading && (
            <div className="center-loader">
             <LoadingSpinner />
            </div>
         )}         
          {!isLoading && loadedIzvestaji &&
           <div>
             <Search onSearch= {onSearch} search={search}/>
            <IzvestajiList items={loadedIzvestaji} />
            {(page> 8) && <Pagination
        postsPerPage={8}
        totalPosts={page}
        isActive = {isActive}
        paginate={paginate}
      />}
            </div>
            }           
        </div>
       )
    };


export default Izvestaji;